import { render, staticRenderFns } from "./BaseCardHeader.vue?vue&type=template&id=1e5a0143"
import script from "./BaseCardHeader.vue?vue&type=script&lang=js"
export * from "./BaseCardHeader.vue?vue&type=script&lang=js"
import style0 from "./BaseCardHeader.vue?vue&type=style&index=0&id=1e5a0143&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports